/**
 * BundleBadge — Indigo pill badge indicating an item is a Product Bundle.
 *
 * Two sizes:
 * - "default" for detail header
 * - "sm" for list rows
 *
 * Plan: 171-bundle-product-ux, Epic 02
 */

import { Package } from "lucide-react";
import { cn } from "@/lib/utils";

interface BundleBadgeProps {
  size?: "default" | "sm";
  className?: string;
}

export function BundleBadge({ size = "default", className }: BundleBadgeProps) {
  const isSmall = size === "sm";

  return (
    <span
      role="status"
      aria-label="Bundle product"
      className={cn(
        "inline-flex items-center gap-1 rounded-full border font-medium whitespace-nowrap",
        "bg-indigo-50 text-indigo-700 border-indigo-200",
        "dark:bg-indigo-950/40 dark:text-indigo-400 dark:border-indigo-800",
        isSmall ? "text-[10px] px-1.5 py-0.5" : "text-[11px] px-2 py-0.5",
        className,
      )}
    >
      <Package className={isSmall ? "h-2.5 w-2.5" : "h-3 w-3"} />
      Bundle
    </span>
  );
}
